import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Dec 31 2019
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
export var DPWorkflowConfigTreeNode =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPWorkflowConfigTreeNode, _DomainObject);

  function DPWorkflowConfigTreeNode(path, name, id, defaults, tasks) {
    var _this;

    _classCallCheck(this, DPWorkflowConfigTreeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPWorkflowConfigTreeNode).call(this));
    _this.path = path;
    _this.name = name;
    _this.id = id;
    _this.defaults = defaults;
    _this.tasks = tasks;
    return _this;
  }

  return DPWorkflowConfigTreeNode;
}(DomainObject);